import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

const BUCKET = 'business_assets';
const SIGNED_TTL_SECONDS = 60 * 60 * 24 * 7; // 7 ימים

async function resolve(pathOrUrl: string | null): Promise<string | null> {
  if (!pathOrUrl) return null;
  if (pathOrUrl.startsWith('http')) return pathOrUrl;

  // תמיד ננסה קודם signed URL (עובד גם אם הבאקט ציבורי)
  const { data: signed, error } = await supabase
    .storage
    .from(BUCKET)
    .createSignedUrl(pathOrUrl, SIGNED_TTL_SECONDS);

  if (signed?.signedUrl && !error) {
    return signed.signedUrl;
  }

  // נפילה אחורה ל-publicUrl רק אם לא הצלחנו לחתום
  const { data: pub } = supabase.storage.from(BUCKET).getPublicUrl(pathOrUrl);
  return pub?.publicUrl ?? null;
}

export function useLogoSrc(rawLogoUrl: string | null | undefined) {
  const [src, setSrc] = useState<string | null>(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      const url = await resolve(rawLogoUrl ?? null);
      if (!mounted) return;
      // cache-busting כדי לעקוף CDN / מטמון
      setSrc(url ? `${url}${url.includes('?') ? '&' : '?'}v=${Date.now()}` : null);
    })();
    return () => { mounted = false; };
  }, [rawLogoUrl]);

  return src;
}
